const errorMappings = {
  'value not found': 'Data telah dihapus dari sistem',
  'value is not unique': 'Nama Template sudah terdaftar di sistem.'
}

export default errorMappings